import React, { createContext, useContext, useState, useCallback } from 'react';
import api from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('hrtrack_user')); } catch { return null; }
  });
  const [token, setToken] = useState(() => localStorage.getItem('hrtrack_token'));

  const login = useCallback(async (username, password) => {
    const data = await api.post('/auth/login', { username, password }).then(r => r.data);
    localStorage.setItem('hrtrack_token', data.token);
    localStorage.setItem('hrtrack_user', JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const updateUser = useCallback((userData) => {
    localStorage.setItem('hrtrack_user', JSON.stringify(userData));
    setUser(userData);
    if (userData.token) {
      localStorage.setItem('hrtrack_token', userData.token);
      setToken(userData.token);
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('hrtrack_token');
    localStorage.removeItem('hrtrack_user');
    setToken(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{
      user, token, login, logout, updateUser,
      isAdmin: user?.role === 'admin' || user?.role === 'manager',
      isManager: user?.role === 'manager',
      isSuperAdmin: user?.role === 'admin',
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
